<template>
  <v-dialog :value="true" width="750">
    <v-card>
      <v-card-title class="primary text-h6 white--text">
        Excluir inscrição? Esta ação não poderá ser desfeita.
      </v-card-title>

      <v-card-text class="py-3">
        <v-row>
          <v-col cols="12"> Protocolo: {{ inscricao.protocolo }} </v-col>
          <v-col cols="12">
            Aluno:
            {{ inscricao.matricula.pessoa.nome }}
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider />

      <v-card-actions class="d-flex justify-end">
        <CPTBtn label="Não" @click="$emit('close')" />
        <CPTBtn label="Sim" @click="$emit('delete', inscricao)" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CPTBtn from "@/components/Btn";

export default {
  name: "dialog-exclusao-inscricao",
  components: {
    CPTBtn
  },
  props: {
    inscricao: {
      type: Object,
      required: true
    }
  }
};
</script>
